<template>
    <van-popup
        v-if="addMembersPopupShow"
        :value="addMembersPopupShow"
        z-index="100"
        :close-on-click-overlay="false"
        :style="{ height: '100vh', width: '100vw', background: 'rgba(0,0,0,.3)' }"
        overlay-class="custom_popup"
        position="right"
    >
        <div class="public_container customer_members_list" v-loading="loading">
            <div class="returnNavBar">
                <div class="returnNavBarLeft" @click="handleClickClose">
                    <van-icon  name="arrow-left" />
                    <span class="normal_title">返回</span>
                </div>
                <div class="returnNavBarRight">
                    <span @click="handleClickAdd">+新增</span>
                </div>
            </div>
            <div class="mobile_container">
                <van-form
                    label-width="9.5em"
                    input-align="right"
                    scroll-to-error
                    :show-error-message="false"
                    ref="customerForm"
                    class=""
                >
                    <div v-for="(item, index) in formData.memberList" :key="index" class="form_group">
                        <van-field
                            required
                            :value="item.memberName"
                            name="memberName"
                            label="人员"
                            placeholder="请选择"
                            is-link
                            readonly
                            @click="handleClickSelectUser(item, index)"
                            :rules="[{ required: true, message: '请选择' }]"
                        >
                        </van-field>
                        <van-field
                            required
                            :value="item.authName"
                            name="auth"
                            label="权限"
                            placeholder="请选择"
                            is-link
                            readonly
                            @click="handleClickSelectAuth(item, index)"
                            :rules="[{ required: true, message: '请选择' }]"
                        >
                        </van-field>
                        <i class="iconfont icon-guanbi1 form_group_delete" @click="handleClickDelete(item, index)"></i>
                    </div>
                </van-form>
            </div>
            <div class="add_footer_wrap">
                <van-button
                    round
                    block
                    type="info"
                    :disabled="btnDisabled || !formData.memberList.length"
                    @click="handleClickConfirm"
                    >确定</van-button
                >
            </div>

            <UserSearchSelect
                :userSelectVisible.sync="userSelectVisible"
                :userSelectTitle="'人员'"
                @selectUserData="handleSelectUserData"
                v-if="userSelectVisible"
            />

            <van-action-sheet
                v-model="authVisible"
                :actions="authActions"
                cancel-text="取消"
                close-on-click-action
                @select="handleAuthConfirm"
                @cancel="handleAuthCancel"
            />
        </div>
    </van-popup>
</template>

<script>
import { GetCustomerMemberList, HandleCustomerMember } from "@/api";
import UserSearchSelect from "@/components/mComponents/UserSearchSelect.vue";
export default {
    name: "CustomerMembersList",
    components: { UserSearchSelect },
    props: {
        addMembersPopupShow: {
            type: Boolean,
            default: false
        },
        customer_id: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            loading: false,
            formData: {
                memberList: [],
            },
            btnDisabled: false,
            currentSelectIndex: 0, // 当前选择项
            userSelectVisible: false,
            authVisible: false,
            authActions: [
                { name: "只读", value: "1" },
                { name: "读写", value: "2" },
            ],
        };
    },
    created() {
        this.getCustomerMemberList();
    },
    methods: {
        handleClickClose() {
            this.$emit("update:addMembersPopupShow", false)
        },
        handleClickAdd() {
            this.formData.memberList.push({ member_uid: "", memberName: "", auth: "1", authName: "只读" });
        },
        handleClickDelete(item, index) {
            if (item.id) {
                // 已经上传的数据
                const params = {
                    customer_id: this.customer_id,
                    delete: [item.id],
                };
                HandleCustomerMember(params).then((res) => {
                    if (res.code === 200) {
                        this.formData.memberList.splice(index, 1);
                        this.$toast({
                            message: "删除成功",
                            type: "success",
                        });
                    } else {
                        this.$toast({
                            message: res.message,
                            type: "fail",
                        });
                    }
                });
            } else {
                // 新增未上传的数据
                this.formData.memberList.splice(index, 1);
            }
        },
        // 选择人员
        handleClickSelectUser(item, index) {
            this.currentSelectIndex = index;
            this.userSelectVisible = true;
        },
        // 选择权限
        handleClickSelectAuth(item, index) {
            this.currentSelectIndex = index;
            this.authVisible = true;
        },
        handleSelectUserData(data) {
            this.$set(this.formData.memberList[this.currentSelectIndex], "member_uid", data.uid);
            this.$set(this.formData.memberList[this.currentSelectIndex], "memberName", data.name);
        },
        handleAuthConfirm(data) {
            this.$set(this.formData.memberList[this.currentSelectIndex], "auth", data.value);
            this.$set(this.formData.memberList[this.currentSelectIndex], "authName", data.name);
        },
        handleAuthCancel() {
            this.authVisible = false;
        },
        // 获取成员列表信息
        getCustomerMemberList() {
            this.loading = true;
            GetCustomerMemberList({ customer_id: this.customer_id }).then((res) => {
                if (res.code === 200) {
                    const data = res.data || [];
                    this.formData.memberList = data.map((item) => ({
                        ...item,
                        memberName: item.member_user && item.member_user.name,
                        authName: item.auth == 1 ? "只读" : "读写",
                    }));
                } else {
                    this.formData.memberList = [];
                }
                this.loading = false;
            });
        },
        handleClickConfirm() {
            this.$refs.customerForm.validate().then(() => {
                this.loading = true;
                this.btnDisabled = true;
                const create = this.formData.memberList
                    .filter((item) => !item.id)
                    .map((item) => ({ member_uid: item.member_uid, auth: item.auth }));
                const update = this.formData.memberList
                    .filter((item) => item.id)
                    .map((item) => ({ id: item.id, member_uid: item.member_uid, auth: item.auth }));
                let params = {
                    customer_id: this.customer_id,
                    create,
                    update,
                };
                HandleCustomerMember(params).then((res) => {
                    if (res.code === 200) {
                        this.loading = false;
                        this.btnDisabled = false;
                        this.$toast({
                            message: res.message,
                            type: "success",
                            duration: 1000,
                            onClose: () => {
                                // this.$router.go(-1);
                                this.$emit("update:addMembersPopupShow", false)
                                this.$emit("addMembersSuccess")
                            },
                        });
                    } else {
                        this.loading = false;
                        this.btnDisabled = false;
                        this.$toast({
                            message: res.message,
                            type: "fail",
                        });
                    }
                });
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.returnNavBarRight {
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 0px;
    line-height: 22px;
    color: rgba(41, 144, 255, 1);
}
.customer_members_list {
    .mobile_container {
        padding: 18px 16px;
    }
    .form_group {
        margin-bottom: 18px;
        position: relative;
        .form_group_delete {
            position: absolute;
            top: -8px;
            right: -8px;
            font-size: 16px;
            color: rgba(228, 65, 68, 1);
        }
    }
    .add_footer_wrap {
        padding: 5px 16px;
        background-color: rgba(247, 248, 250, 1);

        .van-button {
            border-radius: 8px;
            height: 38px;
            background-color: rgba(114, 182, 255, 1);
            border-color: rgba(114, 182, 255, 1);
        }
    }
}
</style>
